export default "__VITE_ASSET__aedde4e3__"